import React, { useState, useEffect, useContext } from 'react'
import { useDispatch } from 'react-redux'

import styles from './calendaly.module.css'

import { setModal } from '@src/slices/calendarSlices'

import {
	generateWeekDays,
	generateDayHours,
	generateMonthDays,
	daysOfWeek,
	generateNumberOfDaysFromDate,
} from './utils.jsx'
import { useSelector } from 'react-redux'
import { CalendarContext } from '../CalendarContext'
import AppointmentCalendar from './components/AppointmentCalendar.jsx'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import PreviewShareModal from './components/PreviewShareModal.jsx'

const Calendaly = () => {
	const [tag, setTag] = useState('modal')
	return <Container />
}

export default Calendaly

const ModalDelete = () => {
	return (
		<div>
			<div>
				Quitar disponibilidad de la reunión. Las reuniones ya reservadas no se
				eliminarán
			</div>
			<div>Solo esta semana Lunes, 15 de julio 09:00 am - 12:00pm</div>
			<div>Todas las ssemanas Lunes 9:00am - 12:00pm</div>
			<div>
				Toda la disponibilidad Elimina de forma permanente todo el horario de
				reuniones..
			</div>
		</div>
	)
}

const ModalConfirm = () => {
	return (
		<div className={styles.modalConfirm}>
			<div className={styles.header}>
				<b>Horarios para reunión</b>
				<p>Monday, July 15 · 10:00 – 10:30am</p>
				<p>(GMT+02:00) Central European Time - Madrid</p>

				<div>
					<svg fill='none' viewBox='0 0 24 24'>
						<path
							stroke='currentColor'
							strokeLinecap='round'
							strokeLinejoin='round'
							strokeWidth='2'
							d='M14 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm7 11-6-2V9l6-2v10Z'
						/>
					</svg>
					Google Meet video conference info added after booking
				</div>
			</div>
			<div className={styles.form}>
				<div className={styles.title}>
					<svg fill='none' viewBox='0 0 24 24'>
						<path
							stroke='currentColor'
							strokeLinecap='round'
							strokeLinejoin='round'
							strokeWidth='2'
							d='M15 9h3m-3 3h3m-3 3h3m-6 1c-.306-.613-.933-1-1.618-1H7.618c-.685 0-1.312.387-1.618 1M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Zm7 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z'
						/>
					</svg>
					Your contact info
				</div>
				<div className={styles.input}>
					<label>First name</label>
					<input type='text' placeholder={'FacturaGPT'} />
				</div>
				<div className={styles.input}>
					<label>Last name</label>
					<input type='text' placeholder={'Company'} />
				</div>
				<div className={styles.input}>
					<label>Email address</label>
					<input type='text' placeholder={'info@FacturaGPT.com'} />
				</div>
				<div className={styles.buttons}>
					<button>Cancel</button>
					<button className={styles.active}>Book</button>
				</div>
			</div>
		</div>
	)
}

const ModalEdit = ({ setTag }) => {
	return (
		<div>
			<div>
				<div className={styles.dot}></div>
				<div>
					<div>Agenda de reservas de reuniones</div>
					<div>Horarios para reuniones</div>
					<div>Reuniones de {} minutos</div>
				</div>
			</div>
			<div>
				<div>
					<svg fill='none' viewBox='0 0 24 24'>
						<path
							stroke='currentColor'
							strokeLinecap='round'
							strokeLinejoin='round'
							strokeWidth='2'
							d='M3 19V6a1 1 0 0 1 1-1h4.032a1 1 0 0 1 .768.36l1.9 2.28a1 1 0 0 0 .768.36H16a1 1 0 0 1 1 1v1M3 19l3-8h15l-3 8H3Z'
						/>
					</svg>
					Abrir pagina de reserva
				</div>
				<div>
					<svg fill='none' viewBox='0 0 24 24'>
						<path
							stroke='currentColor'
							strokeLinecap='round'
							strokeWidth='2'
							d='M7.926 10.898 15 7.727m-7.074 5.39L15 16.29M8 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm12 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0-11a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z'
						/>
					</svg>
					Compartir
				</div>
			</div>
			<div>
				<div>Ver todas tus paginas de reservas</div>
			</div>
			<ul>
				<li>
					<div>
						<svg fill='none' viewBox='0 0 24 24'>
							<path
								stroke='currentColor'
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								d='M14 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm7 11-6-2V9l6-2v10Z'
							/>
						</svg>
					</div>
					<div>
						Videoconferencia de Google Meet Después de reservar, se generará un
						enlace en Meet
					</div>
				</li>
				<li>
					<div>
						<svg fill='none' viewBox='0 0 24 24'>
							<path
								stroke='currentColor'
								strokeLinecap='round'
								strokeWidth='2'
								d='M9 8h10M9 12h10M9 16h10M4.99 8H5m-.02 4h.01m0 4H5'
							/>
						</svg>
					</div>
					<div>Nombre . Apellido . Dirección de correo electrónico</div>
				</li>
				<li>
					<div>
						<svg fill='none' viewBox='0 0 24 24'>
							<path
								stroke='currentColor'
								strokeLinecap='round'
								strokeLinejoin='round'
								strokeWidth='2'
								d='M4 10h16M8 14h8m-4-7V4M7 7V4m10 3V4M5 20h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1Z'
							/>
						</svg>
					</div>
					<div>Las horas ocupadas de este calendario no se pueden reservar</div>
				</li>
			</ul>
		</div>
	)
}

const Container = () => {
	const dispatch = useDispatch()
	const { user } = useSelector((state) => state.user)
	const { selectedCalendarData } = useSelector((state) => state.calendar)
	const {
		handlePreviousAppointmentsMonth,
		handleNextAppointmentsMonth,
		currentAppointmentsYear,
		currentAppointmentsMonth,
		formattedAppointmentsMonth,
	} = useContext(CalendarContext)
	
	if (Object.keys(selectedCalendarData).length === 0) return null
	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<div className={styles.title}>
					<p>Visto como {user.user}</p>
					<a>Mira lo que otros ven</a>
				</div>
				<div
					onClick={() => {
						dispatch(
							setModal(
								<PreviewShareModal onClose={() => dispatch(setModal())} />
							)
						)
					}}
					className={styles.share}
				>
					<svg fill='none' viewBox='0 0 24 24'>
						<path
							stroke='currentColor'
							strokeLinecap='round'
							strokeWidth='2'
							d='M7.926 10.898 15 7.727m-7.074 5.39L15 16.29M8 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm12 5.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm0-11a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z'
						/>
					</svg>
					Compartir
				</div>
			</div>
			<div
				className={styles.subHeader}
				style={{ background: `var(--f5-background)` }}
			>
				<div className={styles.left}>
					<div>{selectedCalendarData?.owner ? selectedCalendarData?.owner[0]?.toUpperCase() : ''}</div>
					<p>{selectedCalendarData?.calendarName ? selectedCalendarData?.calendarName : ''}</p>
				</div>
				<div className={styles.right}>
					<b>Horarios para reunión</b>
					<ul>
						<li className={styles.liText}>
							<svg fill='none' viewBox='0 0 24 24'>
								<path
									stroke='currentColor'
									strokeLinecap='round'
									strokeLinejoin='round'
									strokeWidth='2'
									d='M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z'
								/>
							</svg>
							Reuniones de {selectedCalendarData?.eventsDuration} minutos
						</li>
						<li className={styles.liText}>
							<svg fill='none' viewBox='0 0 24 24'>
								<path
									stroke='currentColor'
									strokeLinecap='round'
									strokeLinejoin='round'
									strokeWidth='2'
									d='M14 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm7 11-6-2V9l6-2v10Z'
								/>
							</svg>
							Informacion sobre video conferencia en FacturaGPT Meet luego de
							agendar una reunión
						</li>
					</ul>
				</div>
			</div>
			<div className={styles.calendar}>
				<div className={styles.left}>
					<b className={styles.title}>Selecciona una reunión</b>
					<div className={styles.date}>
						<b>{formattedAppointmentsMonth}</b>
						<div>
							<button onClick={handlePreviousAppointmentsMonth}>
								<FaChevronLeft />
							</button>
							<button onClick={handleNextAppointmentsMonth}>
								<FaChevronRight />
							</button>
						</div>
					</div>
					<div className={styles.miniCalendar}>
						<AppointmentCalendar
							year={currentAppointmentsYear}
							month={currentAppointmentsMonth}
						/>
					</div>
				</div>
				<div className={styles.eventContainer}>
					<Calendar />
				</div>
			</div>
		</div>
	)
}




const Calendar = () => {
	const {
		isHourInRange,
		selectedAppointmentsDate,
		convertTo24Hour: transformHour,
		hourFormat,
	} = useContext(CalendarContext)
	const { selectedCalendarData, selectedCalendarEvents } = useSelector(
		(state) => state.calendar
	)
	const dispatch = useDispatch()
	const { day, month, year } = selectedAppointmentsDate
	const currentDate = new Date(year, month, day)
	const startDate = currentDate
	const daysOfWeek = generateNumberOfDaysFromDate(startDate, 20)
	const duration = selectedCalendarData.eventsDuration || 30
	const hoursOfDay = generateDayHours(6, 22, duration)

	const settings = selectedCalendarData.workingHoursSettings

	const handleClickCell = () => {
		dispatch(setModal(<ModalConfirm />))
	}

	const isHourOccupied = (day, hour) => {
		const dayDate = new Date(year, month, parseInt(day.split(' ')[1]))
		const formattedDay = `${dayDate.getDate().toString().padStart(2, '0')}/${(dayDate.getMonth() + 1).toString().padStart(2, '0')}/${dayDate.getFullYear()}`

		return selectedCalendarEvents?.some((event) => {
			if (event.date === formattedDay) {
				const [eventStart, eventEnd] = event.hour
					.split(' - ')
					.map((h) => convertTo24Hour(h.trim()))

				const currentHour = convertTo24Hour(hour)
				const eventStartTime = new Date(`1970-01-01T${eventStart}:00`)
				const eventEndTime = new Date(`1970-01-01T${eventEnd}:00`)

				const currentHourTime = new Date(`1970-01-01T${currentHour}:00`)
				return (
					currentHourTime >= eventStartTime && currentHourTime < eventEndTime
				)
			}
			return false
		})
	}

	const convertTo24Hour = (time12h) => {
		const [time, modifier] = time12h.split(/(AM|PM)/i)
		let [hours, minutes] = time.trim().split(':')

		if (hours === '12') {
			hours = '00'
		}
		if (modifier.toUpperCase() === 'PM' && hours !== '12') {
			hours = (parseInt(hours, 10) + 12).toString()
		}
		return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`
	}

	const isHourDisabled = (day, hour, duration, dayNumber) => {
		const dayMapping = {
			DOM: 'Domingo',
			LUN: 'Lunes',
			MAR: 'Martes',
			MIÉ: 'Miércoles',
			JUE: 'Jueves',
			VIE: 'Viernes',
			SAB: 'Sábado',
		}

		const mappedDay = dayMapping[day]
		if (!settings[mappedDay]) {
			return true
		}

		const occupied = isHourOccupied(dayNumber, hour)

		return (
			!isHourInRange(
				hour,
				settings[mappedDay].hoursRanges,
				parseInt(duration)
			) && !occupied
		)
	}


	return (
		<div className={styles.calendarSchedule}>
			<div className={styles.days}>
				{daysOfWeek.map((day, dayIndex) => {
					const dayName = day.split(' ')[0]
					return (
						<div key={day} className={styles.dayColumn}>
							<div className={styles.dayHeader}>{day}</div>
							{hoursOfDay.map((hour, hourIndex) => {
								const occupied = isHourOccupied(day, hour)
								const disabled = isHourDisabled(dayName, hour, duration, day)

								const className = occupied
									? styles.occupiedHour
									: disabled
										? styles.disabledHour
										: styles.hour

								return (
									<div
										key={hour}
										className={className}
										onClick={
											!disabled && !occupied
												? () => handleClickCell(hour, day)
												: null
										}
									>
										{hourFormat === '1:00pm' ? hour : transformHour(hour)}
									</div>
								)
							})}
						</div>
					)
				})}
			</div>
		</div>
	)
}
